import React, { useEffect, useState } from 'react'; 
import axios from 'axios';
import { COURSES_URL, ENROLLMENT_URL } from '../../Services/courseService';
import CourseTemplate from './CourseTemplate';
import ClipLoader from 'react-spinners/ClipLoader';
import { useTranslation } from 'react-i18next';

const RecommendedCourses = () => {
     const [recommendedCourses, setRecommendedCourses] = useState([]);
    const [loading, setLoading] = useState(true);
    const userId = localStorage.getItem('userId');
    const { t } = useTranslation(); 
 
    useEffect(() => {

        const loadEnrollments = async () => {
            setLoading(true);
            try {
                const res = await axios.get(`${ENROLLMENT_URL}/${userId}/enrollments`);
                const resJson = res?.data;
 
                const completedCourses = resJson
                    ?.filter(course => course?.completedAt)
                    ?.sort((a, b) => new Date(b?.completedAt) - new Date(a?.completedAt))
                    ?.slice(0, 3);
                    const recommendations = await Promise.all(completedCourses?.map(async (course) => {
                        const categoryResponse = await axios.get(`${COURSES_URL}/course/recommendations/category/${course?.courseId}`);
                        const subcategoryResponse = await axios.get(`${COURSES_URL}/course/recommendations/subcategory/${course?.courseId}`);
                        const courseDetailsResponse = await axios.get(`${COURSES_URL}/course/${course?.courseId}`);
                        const courseTitle = courseDetailsResponse?.data?.data?.title;                    
                        const combinedCourses = [...subcategoryResponse?.data, ...categoryResponse?.data];
                    
                        const uniqueCoursesMap = {};
                        combinedCourses?.forEach(course => {
                            if (!uniqueCoursesMap[course?.courseId]) {
                                uniqueCoursesMap[course?.courseId] = course;
                            }
                        });
                    
                        const uniqueCourses = Object?.values(uniqueCoursesMap);
                    
                        return {
                            id: course?.courseId,  
                            title: courseTitle,
                            courses: uniqueCourses
                        };
                    }));
                    

                 setRecommendedCourses(recommendations);
            } catch (error) {
                console.error("Error loading enrollments:", error);
            } finally {
                setLoading(false);
            }
        };
    

    if (userId) {
        loadEnrollments();
    }else{
        setLoading(false);
      }
    }, [userId]);

    const titles = [
        `Recommended Courses Based on Your Recent Completion: `,
        `Explore Courses Related to Your Recent Completion: `,
        `You May Like These Courses After Completing: `,
        `Discover New Courses Based on Your Recent Completion: `,
        `Courses Suggested After Your Recent Completion: `
    ];

    return (
        <div>
            {loading ? (
                <ClipLoader color="#333333" loading={loading} size={30} id='clipLoader' />
            ) : recommendedCourses?.length > 0 && (
                recommendedCourses?.map((recommended, index) => (
                    <CourseTemplate
                        key={recommended?.id}  
                        coursesData={recommended?.courses}
                        pageTitle={`${t(`${titles[index % titles?.length]}`)}${recommended?.title}`}
                    />
                ))
            ) }


            
        </div>
    );
};

export default RecommendedCourses;
